import { render, staticRenderFns } from "./CreateEditGallery.vue?vue&type=template&id=48b86353&scoped=true&"
import script from "./CreateEditGallery.vue?vue&type=script&lang=js&"
export * from "./CreateEditGallery.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditGallery.vue?vue&type=style&index=0&id=48b86353&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b86353",
  null
  
)

export default component.exports